import CryptoJS from 'crypto-js';

const getUpdatedKey = (key: string) => CryptoJS.SHA256(key + window.location.hostname).toString();

export const encrypt = (value: string, key: string) => {
  const encrypted = CryptoJS.AES.encrypt(value, getUpdatedKey(key)).toString();
  const base64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encrypted));
  return base64;
};

export const decrypt = (value: string, key: string) => {
  const base64 = CryptoJS.enc.Base64.parse(value).toString(CryptoJS.enc.Utf8);
  const decrypted = CryptoJS.AES.decrypt(base64, getUpdatedKey(key));
  return decrypted.toString(CryptoJS.enc.Utf8);
};
